const DEMO_PARAM = "mode";
const DEMO_VALUE = "demo";
const DEMO_SESSION_KEY = "ca-se-prend:demo-session";

function newSessionId() {
  return globalThis.crypto?.randomUUID?.() || `session-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function isDemoMode() {
  return new URLSearchParams(globalThis.location?.search || "").get(DEMO_PARAM) === DEMO_VALUE;
}

export function demoSessionId() {
  if (!isDemoMode()) return null;
  try {
    let id = sessionStorage.getItem(DEMO_SESSION_KEY);
    if (!id) {
      id = newSessionId();
      sessionStorage.setItem(DEMO_SESSION_KEY, id);
    }
    return id;
  } catch {
    return newSessionId();
  }
}

export function storageScope() {
  return isDemoMode() ? `demo:${demoSessionId()}` : "app";
}

export function scopedStorageKey(key) {
  return `ca-se-prend:${storageScope()}:${key}`;
}

export function scopedDatabaseName(name) {
  return `${name}-${storageScope().replaceAll(":", "-")}`;
}

export function enterDemo() {
  const url = new URL(globalThis.location.href);
  url.searchParams.set(DEMO_PARAM, DEMO_VALUE);
  globalThis.location.assign(url);
}

export function exitDemo() {
  const url = new URL(globalThis.location.href);
  url.searchParams.delete(DEMO_PARAM);
  url.searchParams.delete("practice");
  globalThis.location.assign(url);
}

export async function resetDemo() {
  if (!isDemoMode()) return;
  const sessionId = demoSessionId();
  for (let index = localStorage.length - 1; index >= 0; index -= 1) {
    const key = localStorage.key(index);
    if (key?.includes(`demo:${sessionId}`)) localStorage.removeItem(key);
  }
  await new Promise((resolve) => {
    const request = indexedDB.deleteDatabase(scopedDatabaseName("belote-observer-local"));
    request.onsuccess = request.onerror = request.onblocked = resolve;
  });
  sessionStorage.removeItem(DEMO_SESSION_KEY);
  globalThis.location.reload();
}

export const DEMO_DEAL = Object.freeze({
  hand: Object.freeze(["clubs-J", "clubs-9", "clubs-A", "hearts-A", "spades-10"]),
  center: "clubs-K",
  position: "1",
});
